import React from 'react';
import './index.scss';
import { render } from "react-dom";
import Gallery from "react-photo-gallery";
// import { YMInitializer } from 'react-yandex-metrika';
const photos = [
    {
        src: "gallery/01.jpg",
        width: 1200,
        height: 917
    },
    {
        src: "gallery/02.jpg",
        width: 1600,
        height: 1200
    },
    {
        src: "gallery/03.jpg",
        width: 1920,
        height: 1440
    },
    {
        src: "gallery/04.jpg",
        width: 1920,
        height: 1440
    },
    {
        src: "gallery/05.jpg",
        width: 960,
        height: 763
    },
    {
        src: "gallery/06.jpg",
        width: 1632,
        height: 1224
    },
    {
        src: "gallery/07.jpg",
        width: 1920,
        height: 1440
    },
    {
        src: "gallery/08.jpg",
        width: 1280,
        height: 960
    },
    {
        src: "gallery/09.jpg",
        width: 1920,
        height: 1440
    },
    {
        src: "gallery/10.jpg",
        width: 1200,
        height: 1600
    },
    {
        src: "gallery/11.jpg",
        width: 1632,
        height: 1244
    },
    {
        src: "gallery/12.jpg",
        width: 880,
        height: 442
    },

];


const BasicRows = () => <Gallery photos={photos} />;
render(<BasicRows />, document.getElementById("portfolio_text"));
// const YandexMetrika = () => <YMInitializer accounts={[72356887]} options={{webvisor: true}} version="2" />;
// render(<YandexMetrika  />, document.getElementById("yandex-metrika"));
